// src/components/imagepicker/DropZone.jsx
import React, { useState, useCallback } from "react";
import { Box, Typography } from "@mui/material";
import styles from "./styles/styles.module.scss";

export default function DropZone({ disabled = false, onFiles }) {
    const [over, setOver] = useState(false);

    const onDragOver = useCallback(
        (e) => {
            e.preventDefault();
            if (disabled) return;
            setOver(true);
        },
        [disabled]
    );

    const onDragEnter = useCallback(
        (e) => {
            e.preventDefault();
            if (disabled) return;
            setOver(true);
        },
        [disabled]
    );

    const onDragLeave = useCallback(() => setOver(false), []);

    const onDrop = useCallback(
        (e) => {
            e.preventDefault();
            setOver(false);
            if (disabled) return;
            onFiles?.(e.dataTransfer.files);
        },
        [disabled, onFiles]
    );

    return (
        <Box
            className={[
                styles.dropZone,
                over ? styles.dropZoneOver : "",
                disabled ? styles.dropZoneDisabled : "",
            ].join(" ")}
            onDragOver={onDragOver}
            onDragEnter={onDragEnter}
            onDragLeave={onDragLeave}
            onDrop={onDrop}
            role="button"
            tabIndex={0}
        >
            <Typography variant="body2" className={styles.dropText}>
                Перетягніть зображення сюди для завантаження
            </Typography>
            <Typography variant="caption" className={styles.dropHint}>
                PNG / JPG / WEBP • до 5MB
            </Typography>
        </Box>
    );
}